import { render, staticRenderFns } from "./AkinonSelectOrder.vue?vue&type=template&id=70a52cb4"
import script from "./AkinonSelectOrder.vue?vue&type=script&lang=js"
export * from "./AkinonSelectOrder.vue?vue&type=script&lang=js"
import style0 from "./AkinonSelectOrder.vue?vue&type=style&index=0&id=70a52cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports